import Rest from '../rest'

/**
 * @extends Rest
 */
export default class Configuration extends Rest {

    constructor (options = {}) {
        super(options)
    }

    getConfigurations() {
        return this.http.get('/configuration');
    }

    /**
     * Método responsável por fazer um GET nas informações de configuração requisitada.
     * @param {String} config Recebe uma chave referente a configuração requisitada, Ex: *nameBusiness*, *brandLogo*.
     * @returns Retorna o resultado da requisição.
     */
    getConfig(config){
        return this.http.get(`/configuration/${config}`);
    }

    updateConfig(config, data){
        return this.http.put(`/configuration/${config}`, data);
    }
}